const FETCH_ORDER_REMAINING_HOURS_REPORTS = 'fetch_orderRemainingHoursReports';
const FETCH_ORDER_REMAINING_HOURS_REPORTS_TOTALS = 'fetch_orderRemainingHoursReportsTotals';
const FETCH_ORDER_REMAINING_HOURS_REPORTS_CSV = 'fetch_orderRemainingHoursReports_csv';
const FETCH_ORDER_REMAINING_HOURS_REPORT = 'fetch_orderRemainingHoursReport';
const DELETE_ORDER_REMAINING_HOURS_REPORT = 'delete_orderRemainingHoursReport';
const PERSIST_ORDER_REMAINING_HOURS_REPORT = 'persist_orderRemainingHoursReport';
export default {
    FETCH_ORDER_REMAINING_HOURS_REPORTS,
    FETCH_ORDER_REMAINING_HOURS_REPORTS_TOTALS,
    FETCH_ORDER_REMAINING_HOURS_REPORTS_CSV,
    FETCH_ORDER_REMAINING_HOURS_REPORT,
    DELETE_ORDER_REMAINING_HOURS_REPORT,
    PERSIST_ORDER_REMAINING_HOURS_REPORT,
};
